export default function Footer(){
    
    return (
        <footer>
            <div>
                <p className="copyright-text">Copyright &copy; {new Date().getFullYear()} All Rights Reserved by Nick</p>
            </div>
            <div>
                <ul className="social-icons">
                    <li><a className="instagram" href="https://www.instagram.com/nicksei.bert"><i className="fa fa-instagram"></i></a></li>
                    <li><a className="github" href="https://github.com/nseibert-msr"><i className="fa fa-github"></i></a></li>
                    <li><a className="linkedin" href="https://www.linkedin.com/in/nick-seibert-8079b125"><i className="fa fa-linkedin"></i></a></li>   
                </ul>
            </div>
        </footer>
    )
}